import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import { labelPath, labelsPath } from '@/lib/linear-paths';
import type { IssueLabel } from '@/types/label';
import type { SharedPageProps } from '@/types/shared';
import { Form, router, usePage } from '@inertiajs/react';
import { useState } from 'react';

interface Props {
  labels?: IssueLabel[];
}

export default function Index({ labels = [] }: Props) {
  const { workspaceAdmin } = usePage<SharedPageProps>().props;
  const [name, setName] = useState('');

  return (
    <div className="ln-page">
      <PageToolbar title="Labels" showNew={false} />
      <div className="ln-page-scroll" style={{ padding: 24, maxWidth: 640 }}>
        {workspaceAdmin ? (
          <Form
            method="post"
            action={labelsPath()}
            className="ln-settings-row"
            onSuccess={() => setName('')}
          >
            {({ processing }) => (
              <>
                <input
                  className="ln-filter-input"
                  name="label[name]"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  placeholder="New label"
                  aria-label="Label name"
                  required
                  style={{ flex: 1 }}
                />
                <button
                  type="submit"
                  className="ln-primary-btn"
                  disabled={processing || !name.trim()}
                >
                  Create
                </button>
              </>
            )}
          </Form>
        ) : null}
        {labels.length === 0 ? (
          <EmptyState title="No labels" description="Create a label to classify issues." />
        ) : (
          labels.map((label) => (
            <div key={label.id} className="ln-row">
              <span
                className="ln-label"
                style={{ color: label.color, background: `${label.color}22` }}
              >
                {label.name}
              </span>
              {workspaceAdmin ? (
                <button
                  type="button"
                  className="ln-toolbar-btn"
                  style={{ marginLeft: 'auto' }}
                  onClick={() => router.delete(labelPath(label.id))}
                >
                  Delete
                </button>
              ) : null}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
